import i18n, { type InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { ru } from "./locales/ru";
import { en } from "./locales/en";
import { registerZodErrorMap } from "./zodErrorMap";

export const SUPPORTED_LOCALES = ["ru", "en"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

const options: InitOptions = {
  resources: {
    ru: ru as unknown as Record<string, object>,
    en: en as unknown as Record<string, object>,
  },
  fallbackLng: "ru",
  supportedLngs: ["ru", "en"],
  nonExplicitSupportedLngs: true,
  defaultNS: "translation",
  interpolation: { escapeValue: false },
  detection: {
    order: ["localStorage", "navigator"],
    lookupLocalStorage: "gudwin.locale",
    caches: ["localStorage"],
  },
};

void i18n.use(LanguageDetector).use(initReactI18next).init(options);

registerZodErrorMap();

export default i18n;
